import { render, staticRenderFns } from "./LargeLabelsNew.vue?vue&type=template&id=5ac72c72&scoped=true"
import script from "./LargeLabelsNew.vue?vue&type=script&lang=js"
export * from "./LargeLabelsNew.vue?vue&type=script&lang=js"
import style0 from "./LargeLabelsNew.vue?vue&type=style&index=0&id=5ac72c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac72c72",
  null
  
)

export default component.exports